<template>
  <article class="classes">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">
              {{ segment.charAt(0).toUpperCase() + segment.slice(1) }}
            </p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({ name: 'segments' })"
                class="breadcums__option"
              >
                Características de usuario
              </v-breadcrumbs-item>
              <v-breadcrumbs-item disabled class="breadcums__disable">
                {{ segment.charAt(0).toUpperCase() + segment.slice(1) }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <div class="buttom_reload" @click="findValueSegments()">
              <img src="@/assets/img/icons/refresh-icon.svg" />
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <section class="trainers__header">
          <!--<div class="trainers__header--title">
          <div class="dashboard__options--reload" @click="findValueSegments()">
            <img src="@/assets/img/icons/refresh-icon.svg" alt>
          </div>
          <p>{{segment.charAt(0).toUpperCase()+ segment.slice(1)}}</p>

          <v-breadcrumbs style="width: 100%">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item @click="$router.push({name: 'segments'})">Características de usuario</v-breadcrumbs-item>
            <v-breadcrumbs-item disabled>{{segment.charAt(0).toUpperCase()+ segment.slice(1)}}</v-breadcrumbs-item>
          </v-breadcrumbs>
        </div>-->
          <button
            class="trainers__header--button"
            v-if="
              valueSegments[Object.keys(valueSegments)[0]] &&
              valueSegments[Object.keys(valueSegments)[0]].attributes.ranges &&
              valueSegments[Object.keys(valueSegments)[0]].attributes.ranges
                .length > 0 &&
              !isEditing
            "
            @click="isEditing = true"
          >
            Editar valores (rangos)
          </button>
          <button
            class="trainers__header--button"
            v-if="
              valueSegments[Object.keys(valueSegments)[0]] &&
              valueSegments[Object.keys(valueSegments)[0]].attributes.ranges &&
              valueSegments[Object.keys(valueSegments)[0]].attributes.ranges
                .length > 0 &&
              isEditing
            "
            @click="sendEditedData()"
          >
            Guardar valores actuales
          </button>
        </section>
        <section class="classes__container" v-if="!isEditing">
          <section
            class="data_card"
            v-for="valueSegment in valueSegments"
            style="cursor: pointer"
            :key="valueSegment.id"
            @click="
              $router.push({
                name: 'client_segment',
                params: {
                  id: valueSegment.id,
                  name: valueSegment.attributes.value.toLowerCase(),
                  segment: { id: segmentId, name: segment.toLowerCase() },
                },
              })
            "
          >
            <!-- <div
              class="data_card__image"
            :style="{backgroundImage: 'url('+ getImageServer() + segment.images[0].attributes.image.url +')'}"></div>-->
            <div class="data_card__buttons">
              <div class="data_card__buttons--container">
                <div
                  class="data_card__buttons--edit"
                  style="top: 44px; position: absolute; right: -5px"
                  @click="
                    $router.push({
                      name: 'client_segment',
                      params: {
                        id: valueSegment.id,
                        name: valueSegment.attributes.value.toLowerCase(),
                        segment: { id: segmentId, name: segment.toLowerCase() },
                      },
                    })
                  "
                >
                  <v-icon>search</v-icon>
                </div>
              </div>
            </div>
            <div class="data_card__info">
              <p class="data_card__info--title">
                {{
                  valueSegment.attributes.value.charAt(0).toUpperCase() +
                  valueSegment.attributes.value.replace("_", " ").slice(1)
                }}
              </p>
              <p
                class="data_card__info--label"
                v-if="
                  valueSegment.attributes.ranges &&
                  valueSegment.attributes.ranges.length > 0
                "
              >
                {{ valueSegment.attributes.ranges[0] }} -
                {{ valueSegment.attributes.ranges[1] }}
              </p>
            </div>
          </section>
        </section>
        <section v-else>
          <section
            class="data_card"
            style="width: 95%; padding-left: 25px; margin-top: 50px"
          >
            <v-flex style="display: flex">
              <p
                class="data_card__info--title"
                style="
                  font-size: 12px;
                  margin-top: 16px;
                  margin-top: 16px;
                  width: 20%;
                  padding: 12px;
                  padding-left: 5px;
                  height: fit-content;
                  padding-right: 0px;
                "
              >
                Nombre
              </p>
              <p
                class="data_card__info--title"
                style="
                  font-size: 12px;
                  margin-top: 16px;
                  width: 60px;
                  padding: 12px;
                  height: fit-content;
                  padding-right: 0px;
                  margin-left: 6px;
                "
              >
                Desde
              </p>
              <v-flex class="px-2"></v-flex>
              <p
                class="data_card__info--title"
                style="
                  font-size: 12px;
                  margin-top: 16px;
                  width: fit-content;
                  padding: 12px;
                  height: fit-content;
                  padding-right: 84px;
                "
              >
                Hasta antes de
              </p>
            </v-flex>
            <div v-for="(value, position) in editSegments" :key="position">
              <v-flex
                style="display: flex"
                v-if="editSegments[position][1] != '' && renderComponents"
              >
                <input
                  class="accessIndex__text--small"
                  style="
                    margin-top: 16px;
                    width: 20%;
                    padding: 12px;
                    padding-left: 5px;
                    height: fit-content;
                  "
                  :placeholder="value[0].toLowerCase().replace('_', ' ')"
                  @change="value[0] = $event.target.value"
                  @focus="$event.target.select()"
                  :value="value[0].toLowerCase().replace('_', ' ')"
                />
                <v-card-text style="margin-top: -18px">
                  <v-layout>
                    <v-flex class="px-4">
                      <v-range-slider
                        v-model="value[1]"
                        :max="maxRange(value[0].toLowerCase())"
                        :smin="0"
                        :step="sliderStep(maxRange(value[0].toLowerCase()))"
                        hide-details
                        class="align-center"
                        thumb-label
                        ticks
                        type="decimal"
                        v-if="renderComponents"
                        @change="
                          moveSlider(
                            value,
                            position,
                            editSegments,
                            maxRange(value[0].toLowerCase())
                          )
                        "
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            v-model="value[1][0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="float"
                            disabled
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            v-model="value[1][1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="float"
                            disabled
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-range-slider>
                    </v-flex>
                    <div
                      v-if="editSegments.length > 1"
                      @click="deleteValue(editSegments, position)"
                      class="data_card__buttons--delete"
                      style="padding-right: 63px"
                    >
                      <v-icon dark left>remove_circle</v-icon>
                    </div>
                  </v-layout>
                </v-card-text>
              </v-flex>
            </div>
            <div
              class="data_card__buttons"
              style="padding-bottom: 33px; margin-top: 15px"
              v-if="editSegments.length > 0 && editSegments[0][1] != ''"
            >
              <v-flex
                style="display: flex; width: fit-content"
                @click="addSegmentValue(editSegments)"
              >
                <div class="data_card__buttons--edit">
                  <v-icon>add</v-icon>
                </div>
                <p
                  class="accessIndex__text--small"
                  style="margin-top: 12px; margin-left: 10px"
                >
                  Añadir nueva categoría
                </p>
              </v-flex>
            </div>
          </section>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data() {
    return {
      valueSegments: [],
      charged: false,
      segment: "",
      segmentId: 0,
      isEditing: false,
      editSegments: [],
      renderComponents: true,
    };
  },
  methods: {
    findValueSegments() {
      var params = this.$route.params;
      this.segment = params.name;
      this.segmentId = params.id;
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("segment_value/" + params.id, {
            params: { data: data },
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken(),
            },
          })
          .then(
            function (response) {
              var editedSegments = [];
              this.valueSegments = response.body.data;

              for (let segment_value in this.valueSegments) {
                editedSegments.push([
                  this.valueSegments[segment_value].attributes.value,
                  this.valueSegments[segment_value].attributes.ranges,
                ]);
              }
              this.editSegments = editedSegments;
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              this.charged = true;
            },
            function (response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
            }
          );
      } catch (e) {
        alert(e.message);
      }
    },
    sendEditedData() {
      let finalJson = {
        segment_value: this.editSegments,
        segment: this.segmentId,
        company: { id: this.getCompany().id },
      };
      try {
        this.$http
          .post(
            "upload_edited_data",
            {
              data: this.encrypt(finalJson).toString(),
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken(),
              },
            }
          )
          .then(function (response) {
            this.isEditing = false;
            this.findValueSegments();
          });
      } catch (e) {
        alert(e.message);
      }
    },
    maxRange(segment) {
      var self = this;
      var ans = 1;
      var hh = segment;

      let allRanges = Object.keys(this.valueSegments).map(function (x) {
        return self.valueSegments[x].attributes.ranges[1];
      });

      if (allRanges.length > 0) {
        ans = Math.max(...Object.values(allRanges));
      }

      if (ans <= 1) {
        ans = 1;
      } else if (ans <= 10) {
        ans = 10;
      } else if (ans <= 100) {
        ans = 100;
      } else {
        ans += 1;
      }
      return ans;
    },
    sliderStep(myNumber) {
      var ans = 0;
      if (myNumber <= 10) {
        ans = 0.01;
      } else if (myNumber < 50) {
        ans = 0.1;
      } else {
        ans = 1;
      }
      return ans;
    },
    moveSlider(characteristic, position, array, myMaxValue) {
      var size = array.length;
      var maxValue = myMaxValue;
      let range = characteristic[1];

      if (0 != size - 1) {
        if (position == 0) {
          range[0] = 0;
          if (range[1] != array[position + 1][1][0]) {
            array[position + 1][1][0] = range[1];
            if (array[position + 1][1][0] > array[position + 1][1][1]) {
              array[position + 1][1][0] = array[position + 1][1][1];
              this.moveSlider(
                array[position + 1],
                position + 1,
                array,
                myMaxValue
              );
            }
          }
        } else if (position == size - 1) {
          range[1] = myMaxValue;
          if (range[0] != array[position - 1][1][1]) {
            array[position - 1][1][1] = range[0];
            if (array[position - 1][1][0] > array[position - 1][1][1]) {
              array[position - 1][1][1] = array[position - 1][1][0];
              this.moveSlider(
                array[position - 1],
                position - 1,
                array,
                myMaxValue
              );
            }
          }
        } else {
          if (range[0] != array[position - 1][1][1]) {
            array[position - 1][1][1] = range[0];
            if (array[position - 1][1][0] > array[position - 1][1][1]) {
              array[position - 1][1][1] = array[position - 1][1][0];
              this.moveSlider(
                array[position - 1],
                position - 1,
                array,
                myMaxValue
              );
            }
          }
          if (range[1] != array[position + 1][1][0]) {
            array[position + 1][1][0] = range[1];
            if (array[position + 1][1][0] > array[position + 1][1][1]) {
              array[position + 1][1][0] = array[position + 1][1][1];
              this.moveSlider(
                array[position + 1],
                position + 1,
                array,
                myMaxValue
              );
            }
          }
        }
        if (range[0] > range[1]) {
          range[1] = range[0];
        }
      } else {
        range[0] = 0;
        range[1] = maxValue;
      }
      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });
    },
    deleteValue(array, row) {
      let next = -1;
      let greater = 0;
      if (row <= 0) {
        row = 0;
        next = 1;
        greater = 1;
      } else if (row >= array.length - 1) {
        row = array.length - 1;
        next = array.length - 2;
        greater = -1;
      } else {
        if (
          array[row + 1][1][1] - array[row + 1][1][0] >=
          array[row - 1][1][1] - array[row - 1][1][0]
        ) {
          next = row - 1;
          greater = -1;
        } else {
          next = row + 1;
          greater = 1;
        }
      }
      let addition = Number((array[row][1][1] - array[row][1][0]).toFixed(2));

      if (greater > 0) {
        array[next][1][0] -= addition;
        array[next][1][0] = Number(array[next][1][0].toFixed(2));
      } else {
        array[next][1][1] = Number(array[next][1][1]) + Number(addition);
        array[next][1][1] = Number(array[next][1][1].toFixed(2));
      }
      array.splice(row, 1);

      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });
    },
    addSegmentValue(segment) {
      var greaterSegment = segment[segment.length - 1];
      let greaterIntervalus = greaterSegment[1][1] - greaterSegment[1][0];
      let newValue = Number((greaterIntervalus / 2).toFixed(2));

      segment.push([
        "categoría " + Number(segment.length + 1),
        [
          (Number(greaterSegment[1][0]) + Number(newValue)).toFixed(2),
          greaterSegment[1][1],
        ],
      ]);
      greaterSegment[1][1] = Number(
        (Number(greaterSegment[1][0]) + Number(newValue.toFixed(2))).toFixed(2)
      );
      this.renderComponents = false;
      this.$forceUpdate();
      // If you like promises better you can
      // also use nextTick this way
      this.$nextTick().then(() => {
        // Add the component back in
        this.renderComponents = true;
        this.$forceUpdate();
      });
    },
  },
  created() {
    this.findValueSegments();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/segments/Index_segment_value.vue